function About() {
	return (
		<p className="about px-0 px-md-3">
			I am a passionate Computer Scientist with experience in Full-Stack development.
			<br />
			Click on the icons below to download my resume and see my LinkedIn profile!
		</p>
	);
}

export default About;
